import { useState, useEffect } from "react";
import { useFetchPrincipalEntitiesdataQuery } from "../../store/services/principleApi";
import { useGetTemplateByPrincipalIdQuery } from "../../store/services/templateApi";
import { useFetchHeadersByPrincipalIdQuery } from "../../store/services/headerApi ";
import { useGetCustomerCountriesQuery } from "../../store/services/blacklistApi";
import { api } from "../../Appjs/api";
import socketApi from "../../Appjs/socketApi";
import axios from "axios";
import dayjs from "dayjs";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { io } from "socket.io-client";
import { toast } from "react-toastify";
import { FormGroup } from "react-bootstrap";
import { formatedCurrentDateTime } from "../../utility/GetCurrentDateTime";
const smsoption = [
  { id: "bulk", label: "Bulk SMS" },
  { id: "compose", label: "Compose SMS" },
  { id: "customize", label: "Customize SMS" },
  { id: "split", label: "Split SMS" },
];

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const ServiceDropdown = ({ message }) => {
  const [socket, setSocket] = useState(null);
  const [selectedService, setSelectedService] = useState("");
  const [phoneNumbers, setPhoneNumbers] = useState("");
  const [subService, setSubService] = useState("");
  const [thirdService, setThirdService] = useState("");
  const [selectedButton, setSelectedButton] = useState("");
  const [file, setFile] = useState(null);
  const [entityId, setEntityId] = useState(null);
  const [senderId, setSenderId] = useState("");
  const [templates, setTemplates] = useState([]);
  const [prId, setPrId] = useState(null);
  const [principalEntities, setPrincipalEntities] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [enableSchedule, setEnableSchedule] = useState(false);
  const [templateId, setTemplateId] = useState("");
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [isOtherLanguageSelected, setIsOtherLanguageSelected] = useState(false);
  const [rows, setRows] = useState([
    {
      id: 1,
      createDate: "2025-08-13",
      count: 10,
      fieldName: "Email",
      searchField: "",
      lastUse: "2025-08-12",
      selectOption: "",
    },
  ]);
  const [minDateTime, setMinDateTime] = useState(
    dayjs().format("YYYY-MM-DDTHH:mm")
  );
  const [dateTime, setDateTime] = useState(
    dayjs(new Date()).format("YYYY-MM-DDTHH:mm")
  );
  const [isCountryModalOpen, setIsCountryModalOpen] = useState(false);
  const [isPrincipalEntitySelected, setIsPrincipalEntitySelected] =
    useState(false);
  const [isCountrySelected, setIsCountrySelected] = useState(true);
  const [isUploadDisabled, setIsUploadDisabled] = useState(true);
  const [selectedCountry, setSelectedCountry] = useState({
    id: 1,
    name: "India",
    code: "+91",
  });
  const [smstext, setSmsText] = useState("");
  const [smsCount, setSmsCount] = useState(1);
  const [charCount, setCharCount] = useState(0);
  const [headerName, setHeaderName] = useState("");
  const [peId, setPeId] = useState("");
  const [postVia, setPostVia] = useState("");
  const [isFlash, setIsFlash] = useState(false);
  const [isAllow, setIsAllow] = useState(false);
  const [countdownTimer, setCountdownTimer] = useState(null);
  const [transliterationControl, setTransliterationControl] = useState(null);
  const [isTransliterationEnabled, setIsTransliterationEnabled] =
    useState(false);
  const {
    data: headersData,
    isLoading: headersLoading,
    isError: headersError,
  } = useFetchHeadersByPrincipalIdQuery(prId, {
    skip: !prId,
  });
  const {
    data: countriesData,
    isLoading: countriesLoading,
    isError: countriesError,
  } = useGetCustomerCountriesQuery();
  const [isLongMessageWarning, setIsLongMessageWarning] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [charCountState, setCharCountState] = useState(0);
  const [smsCountState, setSmsCountState] = useState(0);
  const [time_interval, settime_interval] = useState("");
  const [batch_size, setbatch_size] = useState("");
  const [sendTime, setSendTime] = useState(
    enableSchedule
      ? dayjs(dateTime).format("YYYY-MM-DD HH:mm")
      : dayjs(new Date()).format("YYYY-MM-DD HH:mm")
  );
  const checkboxClickHandler = () => {
    if (transliterationControl) {
      transliterationControl.toggleTransliteration();
      setIsTransliterationEnabled(
        transliterationControl.isTransliterationEnabled()
      );
    }
  };

  /* ****************socket Connection Established Start********************* */

  useEffect(() => {
    const newSocket = io(socketApi, {
      transports: ["websocket"],
      secure: true,
    });

    setSocket(newSocket);
    newSocket.on("connect", () => {
      console.log("Connected to Socket.IO server");
    });

    newSocket.on("disconnect", () => {
      console.log("Disconnected from Socket.IO server");
    });

    newSocket.on("sendSMSResponse", (data) => {
      console.log("Received sendSMS response:", data);
    });

    return () => {
      newSocket.disconnect();
    };
  }, []);

  /* ******************socket Connection Established End********************* */

  useEffect(() => {
    const loadTransliterationAPI = () => {
      google.load("elements", "1", {
        packages: "transliteration",
        callback: onLoad,
      });
    };

    const script = document.createElement("script");
    script.src = "https://www.google.com/jsapi";
    script.onload = loadTransliterationAPI;
    document.body.appendChild(script);
  }, []);

  const onLoad = () => {
    const txtMessageElement = document.getElementById("txtMessage");
    if (!txtMessageElement) {
      console.warn("txtMessage element not found, retrying in 100ms");
      setTimeout(onLoad, 100);
      return;
    }
    const options = {
      sourceLanguage: "en",
      destinationLanguage: [
        "hi",
        "ar",
        "bn",
        "fa",
        "gu",
        "kn",
        "ml",
        "mr",
        "ne",
        "pa",
        "ta",
        "te",
        "ur",
      ],
      transliterationEnabled: false,
      shortcutKey: "ctrl+g",
    };

    const control = new google.elements.transliteration.TransliterationControl(
      options
    );
    setTransliterationControl(control);

    const ids = ["txtMessage"];
    control.makeTransliteratable(ids);

    setIsTransliterationEnabled(control.isTransliterationEnabled());

    const supportedLanguages =
      google.elements.transliteration.getDestinationLanguages(
        google.elements.transliteration.LanguageCode.ENGLISH
      );
    setLanguages(supportedLanguages);

    control.addEventListener(
      google.elements.transliteration.TransliterationControl.EventType
        .STATE_CHANGED,
      transliterateStateChangeHandler
    );
  };

  const transliterateStateChangeHandler = (e) => {
    setIsTransliterationEnabled(e.transliterationEnabled);
  };

  const languageChangeHandler = () => {
    const dropdown = document.getElementById("ddlLanguage");
    const selectedLang = dropdown.options[dropdown.selectedIndex].value;
    if (transliterationControl) {
      transliterationControl.setLanguagePair(
        google.elements.transliteration.LanguageCode.ENGLISH,
        selectedLang
      );
    }
  };
  const {
    data: principalEntitiesData,
    isLoading,
    isError,
  } = useFetchPrincipalEntitiesdataQuery();
  useEffect(() => {
    if (principalEntitiesData) {
      setPrincipalEntities(principalEntitiesData.data || []);
    }
  }, [principalEntitiesData]);

  const {
    data: templatesData,
    isLoading: templatesLoading,
    isError: templatesError,
  } = useGetTemplateByPrincipalIdQuery(prId, {
    skip: !prId,
  });

  useEffect(() => {
    if (templatesData) {
      setTemplates(templatesData.data || []);
    }
  }, [templatesData]);

  const handleCountrySelection = (country) => {
    setSelectedCountry(country);
    setIsCountryModalOpen(false);
  };
  const handleDelete = (id) => {
    setRows(rows.filter((row) => row.id !== id));
  };
  const handleCountryModalToggle = () => {
    setIsCountryModalOpen(!isCountryModalOpen);
  };

  const handleCountrySelect = (countryId, countryName, countrycode) => {
    const cleanCountryCode = countrycode.trim();
    setSelectedCountry({
      id: countryId,
      name: countryName,
      code: cleanCountryCode,
    });
    setIsCountrySelected(true);

    const mobileInput = document.getElementById("mobile");
    if (mobileInput && mobileInput.value) {
      const mobileNumber = mobileInput.value.trim();
      if (mobileNumber.startsWith(cleanCountryCode)) {
        mobileInput.value = mobileNumber.replace(cleanCountryCode, "").trim();
      }
    }
  };

  const handleSubmit = async () => {
    const currentDateTime = formatedCurrentDateTime();

    if (!isPrincipalEntitySelected) {
      toast.error("Please select a PRINCIPAL ENTITY.");
      return;
    }

    if (!headerName) {
      toast.error("Please select header name ");
      return;
    }

    if (selectedButton === "compose" && !templateId) {
      toast.error("Template ID is required for Compose SMS.");
      return;
    }

    if (enableSchedule) {
      const selectedDateTime = dayjs(sendTime);
      const now = dayjs();

      if (selectedDateTime.isBefore(now)) {
        toast.error("Schedule time cannot be in the past");
        return;
      }
    }

    if (!dateTime) {
      toast.error("Please select a date and time for the message.");
      return;
    }

    const formData = new FormData();

    let postViaValue;
    switch (selectedButton) {
      case "bulk":
        postViaValue = "Bulk";
        break;
      case "compose":
        postViaValue = "Compose";
        break;
      case "customize":
        postViaValue = "customize";
        break;
      case "split":
        postViaValue = "Split";
        break;
      default:
        postViaValue = "";
    }

    formData.append("smstext", smstext || "");
    formData.append("template_id", templateId || "0");
    formData.append("header_name", senderId || "");
    formData.append("pe_id", entityId.pe_id);
    formData.append("country_id", selectedCountry.id || "");
    formData.append("country_code", selectedCountry.code);
    formData.append("post_via", postViaValue);
    formData.append("is_flash", isFlash);
    formData.append("language", smsType);
    formData.append("allowLongSms", isAllow);
    formData.append("smsCount", Number(smsCountState));
    formData.append("charCount", charCountState);

    if (enableSchedule) {
      formData.append("time_to_send", sendTime);
    }

    if (file) {
      formData.append("upload_file", file);
    }

    const mobileNumberInput = document.getElementById("mobile")?.value.trim();
    if (mobileNumberInput && mobileNumberInput !== "") {
      const formattedNumbers = mobileNumberInput
        .split("\n")
        .map((num) => num.replace(selectedCountry.code, "").trim())
        .filter((num) => num !== "");
      formData.append("phone_number", formattedNumbers.join(","));
    }

    if (selectedButton === "split") {
      formData.append("time_interval", time_interval || "");
      formData.append("batch_size", batch_size || "");
    }

    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    try {
      let apiUrl = "";
      if (selectedButton === "bulk") {
        apiUrl = `${api}/sms/uploadfile`;
      } else if (selectedButton === "split") {
        apiUrl = `${api}/sms/split/shedule`;
      } else if (selectedButton === "compose") {
        apiUrl = `${api}/sms/upload/compose`;
      } else if (selectedButton === "customize") {
        apiUrl = `${api}/sms/upload-custom-sms`;
      }

      const response = await axios.post(apiUrl, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Data uploaded successfully!");

      //*******  When data is upload then all feilds blank ******//
      setPhoneNumbers("");
      setFile(null);
      setEntityId(null);
      setSenderId("");
      setHeaderName("");
      setTemplates([]);
      setPrId(null);
      setEnableSchedule(false);
      setTemplateId("");
      setSmsText("");
      setSmsCount(1);
      setCharCount(0);
      setPeId("");
      setPostVia("");
      setIsFlash(false);
      setIsAllow(false);
      setSendTime(formatedCurrentDateTime());

      if (socket && selectedButton === "compose" && !enableSchedule) {
        socket.emit("sendSMS", {
          campaign_id: response.data.data.campaign_id,
        });
      }
      if (selectedButton === "customize") {
        console.log("event fire", { response });

        socket.emit("custom-sms", {
          campaign_id: response.data.campaign_id,
        });
      }
    } catch (error) {
      if (error.response) {
        toast.error(
          error.response.data.message ||
          "An error occurred while uploading the file."
        );
      } else {
        toast.error("An error occurred while uploading the file.");
      }
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    const savedService = localStorage.getItem("selectedService");
    const savedSubService = localStorage.getItem("subService");
    const savedThirdService = localStorage.getItem("thirdService");
    const savedButton = localStorage.getItem("selectedButton");
    const savedFile = localStorage.getItem("file");

    if (savedService) setSelectedService(savedService);
    if (savedSubService) setSubService(savedSubService);
    if (savedThirdService) setThirdService(savedThirdService);
    if (savedButton) setSelectedButton(savedButton);
    if (savedFile) setFile(savedFile);
  }, []);

  useEffect(() => {
    if (selectedService) {
      localStorage.setItem("selectedService", selectedService);
    }
    if (subService) {
      localStorage.setItem("subService", subService);
    }
    if (thirdService) {
      localStorage.setItem("thirdService", thirdService);
    }
    if (selectedButton) {
      localStorage.setItem("selectedButton", selectedButton);
    }
    if (file) {
      localStorage.setItem("file", file.name);
    }
  }, [selectedService, subService, thirdService, selectedButton, file]);

  useEffect(() => {
    setIsUploadDisabled(!(isPrincipalEntitySelected && isCountrySelected));
  }, [isPrincipalEntitySelected, isCountrySelected]);

  const handleMainChange = (event) => {
    setSelectedService(event.target.value);
    setSubService("");
    setThirdService("");
    setSelectedButton("");
  };

  const handleSubChange = (event) => {
    setSubService(event.target.value);
    setThirdService("");
    setSelectedButton("");
  };

  const handleThirdChange = (event) => {
    setThirdService(event.target.value);
  };

  const remainingServices = ["sms", "rcs", "whatsapp"].filter(
    (service) => service !== selectedService
  );

  const remainingAfterSubService = remainingServices.filter(
    (service) => service !== subService
  );

  const handleServiceButtonChange = (radioId) => {
    setSelectedButton(radioId);
    if (radioId === "split") {
      setEnableSchedule(true);
    }
    // window.location.reload();
  };

  useEffect(() => {
    if (!enableSchedule) {
      setSendTime(formatedCurrentDateTime());
    }
  }, [enableSchedule]);
  // ---------------------------------------------------------------------
  const handleEntityChange = (e) => {
    const selectedEntityId = e.target.value;
    setEntityId(selectedEntityId);
    console.log("Selected Entity:", selectedEntityId);
    console.log("Setting prId to:", selectedEntityId.principalentity_id);
    setPrId(selectedEntityId.principalentity_id);
    setIsPrincipalEntitySelected(!!selectedEntityId);
    setSenderId("");
    setHeaders([]);
    setPeId(selectedEntityId.pe_id);
    setSmsText("");
    setTemplateId("");
    setCharCountState(0);
    setSmsCountState(0);
    setTemplates([]);
  };

  const handleSenderChange = (e) => {
    const selectedSenderId = e.target.value;
    setSenderId(selectedSenderId);
    setHeaderName(selectedSenderId); // Remove the fallback value
  };

  useEffect(() => {
    console.log("Headers data:", headersData);
    if (headersData) {
      console.log("Formatted headers:", headersData.data);
      setHeaders(headersData.data || []);
      if (headersData.data?.length > 0) {
        setSenderId(headersData.data[0].header_id);
      }
    }
  }, [headersData]);

  const handleTemplateSelect = (templateText, templateId) => {
    setSmsText(templateText);
    setTemplateId(templateId);
    setIsTemplateModalOpen(false);
    handleSmsTextChange({ target: { value: templateText } });
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const [smsType, setSmsType] = useState(() => {
    return localStorage.getItem("smsType") || "english";
  });
  useEffect(() => {
    localStorage.setItem("smsType", smsType);
  }, [smsType]);

  const handleSmsTypeChange = (event) => {
    const selectedValue = event.target.value;
    setSmsType(selectedValue);
    if (selectedValue === "other") {
      // window.location.reload();
      setSmsText("");
    }
    setSmsText("");
    setCharCountState(0);
    setSmsCountState(0);
    setTemplateId("");
    setPeId("");
    setIsAllow(false);
    setCountdownTimer(null);
  };

  const [alertShown, setAlertShown] = useState(false);
  const calculateSmsCount = (smstext, allowLongSms, language) => {
    let smsCount = 1;
    let messageLength = smstext.length;
    const specialChars = ["^", "|", "{", "}", "[", "]", "\\", "~"];
    let additionalLength = 0;
    smstext.split("").forEach((char) => {
      if (specialChars.includes(char)) {
        additionalLength += 2;
      }
    });
    messageLength += additionalLength;

    let limit = language === "english" ? 160 : 70;
    let maxLengthForMultiPart = language === "english" ? 306 : 132;

    if (messageLength > limit) {
      smsCount = 2;
      let additionalLimit = language === "english" ? 160 + 153 : 70 + 67;

      while (messageLength > additionalLimit) {
        additionalLimit += language === "english" ? 153 : 67;
        smsCount++;
      }
    }

    if (messageLength > maxLengthForMultiPart && allowLongSms) {
      let additionalLimit =
        maxLengthForMultiPart + (language === "english" ? 153 : 67);
      while (messageLength > additionalLimit) {
        additionalLimit += language === "english" ? 153 : 67;
        smsCount++;
      }
    }

    return { smsCount, messageLength };
  };

  const handleSmsTextChange = (e) => {
    const text = e.target.value;
    setSmsText(text);

    let newCharCount = 0;
    const specialSymbols = ["^", "|", "{", "}", "[", "]", "\\", "~"];

    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      if (specialSymbols.includes(char)) {
        newCharCount += 2;
      } else {
        newCharCount += 1;
      }
    }

    setCharCountState(newCharCount);

    const language = smsType === "other" ? "other" : "english";
    const { smsCount } = calculateSmsCount(text, isAllow, language);
    setSmsCountState(smsCount);

    const singleSmsLimit = smsType === "other" ? 70 : 160;
    if (newCharCount > singleSmsLimit && !isAllow) {
      setIsLongMessageWarning(true);
      if (!alertShown) {
        alert(
          `Message exceeds ${singleSmsLimit} characters and will take multiple SMS!`
        );
        setAlertShown(true);
      }
    } else {
      setIsLongMessageWarning(false);
    }
  };

  useEffect(() => {
    if (smsType === "other" && charCountState > 70 && !alertShown) {
      alert("Message exceeds 70 characters for Other SMS!");
      setAlertShown(true);
      const allowLongMsgCheckbox = document.getElementById("allowLongMsg");
      if (allowLongMsgCheckbox) {
        allowLongMsgCheckbox.checked = true;
      }
      setIsAllow(true);
    }
  }, [smsType, charCountState, alertShown]);
  console.log({ isTransliterationEnabled });

  return (
    <>
      <div >
        <div className="flex flex-col md:flex-row ">
          {/* Sidebar */}
          {/* Main Content */}
          <main className="flex-1 p-6  p-4 ">
            <Box sx={{ bgcolor: "transparent", boxShadow: 2, width: "100%" }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select a Service
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Select a Service"
                  value={selectedService}
                  onChange={handleMainChange}
                >
                  <MenuItem value="">Choose Service</MenuItem>
                  <MenuItem value="sms">SMS</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {selectedService && (
              <Box
                sx={{
                  mt: 4,
                  p: 4,
                  width: "100%",
                  borderRadius: 5,
                  bgcolor: "rgba(255, 255, 255, 0.5)",
                  backdropFilter: "blur(8px)",
                }}
              >
                {selectedService === "sms" && (
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      {smsoption?.map((radio) => (
                        <FormControlLabel
                          key={radio.id}
                          value={radio.id}
                          control={<Radio />}
                          label={radio.label}
                          checked={selectedButton === radio.id}
                          onChange={() => handleServiceButtonChange(radio.id)}
                          sx={{ "& .MuiFormControlLabel-label": { color: "#000" } }} // ⚡ Fix white text
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                )}

                <div className="d-flex gap-3 mt-4">
                  {selectedButton === "customize" && (
                    <>
                      <Button
                        component="label"
                        role={undefined}
                        variant="outlined"
                        tabIndex={-1}
                        startIcon={<CloudUploadIcon />}
                        sx={{ width: "100%", height: 60, marginBottom: 3 }}
                      >
                        Choose File:
                        <VisuallyHiddenInput
                          type="file"
                          id="fileUpload"
                          onChange={handleFileChange}
                          multiple
                        />
                      </Button>
                      {file && <p>{file.name}</p>}
                      {/* Open Dialog Button */}
                      <Button
                        variant="contained"
                        sx={{ width: "100%", height: 60 }}
                        onClick={() => setOpenDialog(true)}
                      >
                        Open Table
                      </Button>
                    </>
                  )}

                  {/* Dialog with Table */}
                  <Dialog
                    open={openDialog}
                    onClose={() => setOpenDialog(false)}
                    maxWidth="lg"
                    fullWidth
                  >
                    <DialogTitle>Fields Table</DialogTitle>
                    <DialogContent>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Sr Number</TableCell>
                            <TableCell>Create Date</TableCell>
                            <TableCell>Count</TableCell>
                            <TableCell>Field Name</TableCell>
                            <TableCell>Search Field</TableCell>
                            <TableCell>Last Use</TableCell>
                            <TableCell>Select Option</TableCell>
                            <TableCell>Delete</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((row, index) => (
                            <TableRow key={row.id}>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{row.createDate}</TableCell>
                              <TableCell>{row.count}</TableCell>
                              <TableCell>{row.fieldName}</TableCell>
                              <TableCell>
                                <TextField
                                  variant="outlined"
                                  size="small"
                                  value={row.searchField}
                                  onChange={(e) => {
                                    const updatedRows = [...rows];
                                    updatedRows[index].searchField =
                                      e.target.value;
                                    setRows(updatedRows);
                                  }}
                                />
                              </TableCell>
                              <TableCell>{row.lastUse}</TableCell>
                              <TableCell>
                                <Select
                                  size="small"
                                  value={row.selectOption}
                                  onChange={(e) => {
                                    const updatedRows = [...rows];
                                    updatedRows[index].selectOption =
                                      e.target.value;
                                    setRows(updatedRows);
                                  }}
                                >
                                  <MenuItem value="Option 1">Option 1</MenuItem>
                                  <MenuItem value="Option 2">Option 2</MenuItem>
                                </Select>
                              </TableCell>
                              <TableCell>
                                <IconButton
                                  onClick={() => handleDelete(row.id)}
                                >
                                  {/* <DeleteIcon /> */}
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setOpenDialog(false)}>
                        Close
                      </Button>
                    </DialogActions>
                  </Dialog>
                  {selectedButton === "compose" && (
                    <TextField
                      id="mobile"
                      multiline
                      fullWidth
                      rows={4}
                      sx={{ mb: 4 }}
                      label="Mobile Number:"
                      placeholder="Enter Mobile Numbers (one per line)"
                      value={phoneNumbers}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9\n]/g, "a");
                        setPhoneNumbers(value);
                      }}
                    />
                  )}

                  {(selectedButton === "split" ||
                    selectedButton === "bulk") && (
                      <>
                        <Button
                          component="label"
                          role={undefined}
                          variant="outlined"
                          tabIndex={-1}
                          startIcon={<CloudUploadIcon />}
                          sx={{ width: "50%", height: 60, marginBottom: 3 }}
                        >
                          Choose File:
                          <VisuallyHiddenInput
                            type="file"
                            id="fileUpload"
                            onChange={handleFileChange}
                            multiple
                          />
                        </Button>
                        {file && <p>{file.name}</p>}
                        {/* Open Dialog Button */}
                        <Button
                          variant="contained"
                          sx={{ width: "100%", height: 60 }}
                          onClick={() => setOpenDialog(true)}
                        >
                          Open Table
                        </Button>
                      </>
                    )}

                  {/* Dialog with Table */}
                  <Dialog
                    open={openDialog}
                    onClose={() => setOpenDialog(false)}
                    maxWidth="lg"
                    fullWidth
                  >
                    <DialogTitle>Fields Table</DialogTitle>
                    <DialogContent>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Sr Number</TableCell>
                            <TableCell>Create Date</TableCell>
                            <TableCell>Count</TableCell>
                            <TableCell>Field Name</TableCell>
                            <TableCell>Search Field</TableCell>
                            <TableCell>Last Use</TableCell>
                            <TableCell>Select Option</TableCell>
                            <TableCell>Delete</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((row, index) => (
                            <TableRow key={row.id}>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{row.createDate}</TableCell>
                              <TableCell>{row.count}</TableCell>
                              <TableCell>{row.fieldName}</TableCell>
                              <TableCell>
                                <TextField
                                  variant="outlined"
                                  size="small"
                                  value={row.searchField}
                                  onChange={(e) => {
                                    const updatedRows = [...rows];
                                    updatedRows[index].searchField =
                                      e.target.value;
                                    setRows(updatedRows);
                                  }}
                                />
                              </TableCell>
                              <TableCell>{row.lastUse}</TableCell>
                              <TableCell>
                                <Select
                                  size="small"
                                  value={row.selectOption}
                                  onChange={(e) => {
                                    const updatedRows = [...rows];
                                    updatedRows[index].selectOption =
                                      e.target.value;
                                    setRows(updatedRows);
                                  }}
                                >
                                  <MenuItem value="Option 1">Option 1</MenuItem>
                                  <MenuItem value="Option 2">Option 2</MenuItem>
                                </Select>
                              </TableCell>
                              <TableCell>
                                <IconButton
                                  onClick={() => handleDelete(row.id)}
                                >
                                  {/* <DeleteIcon /> */}
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setOpenDialog(false)}>
                        Close
                      </Button>
                    </DialogActions>
                  </Dialog>
                  {(selectedButton === "split" ||
                    selectedButton === "bulk") && (
                      <TextField
                        id="mobile"
                        multiline
                        fullWidth
                        rows={4}
                        sx={{ mb: 4 }}
                        label="Mobile Number:"
                        placeholder="Enter Mobile Numbers (one per line)"
                        value={phoneNumbers}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9\n]/g, "");
                          setPhoneNumbers(value);
                        }}
                      />
                    )}
                </div>
                {selectedButton && (
                  <div className="  border rounded-lg bg-gray-200 w-full">
                    {(selectedButton === "bulk" ||
                      selectedButton === "split" ||
                      selectedButton === "compose" ||
                      selectedButton === "customize") && (
                        <Box sx={{ bgcolor: "#fff", p: 3, width: "100%" }}>
                          {selectedButton === "bulk" && (
                            <h3 className="text-xl font-semibold mb-4">
                              Bulk SMS
                            </h3>
                          )}
                          {selectedButton === "compose" && (
                            <h3 className="text-xl font-semibold mb-4">
                              Compose SMS
                            </h3>
                          )}
                          {selectedButton === "customize" && (
                            <h3 className="text-xl font-semibold mb-4">
                              Customize SMS
                            </h3>
                          )}

                          {selectedButton === "split" && (
                            <h3 className="text-xl font-semibold mb-4">
                              Split SMS
                            </h3>
                          )}

                          <div className="flex space-x-4 mb-6">
                            <label className="flex items-center space-x-2">
                              <input
                                type="radio"
                                name="smsType"
                                value="english"
                                checked={smsType === "english"}
                                onChange={handleSmsTypeChange}
                              />
                              <span style={{ color: "#000" }}>English SMS</span>
                            </label>
                            <label className="flex items-center space-x-2">
                              <input
                                type="radio"
                                name="smsType"
                                value="other"
                                checked={smsType === "other"}
                                onChange={handleSmsTypeChange}
                              />
                              <span style={{ color: "#000" }}>Other SMS (हिंदी व अन्य भाषाएँ)</span>
                            </label>
                          </div>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                              <FormControl fullWidth sx={{ mb: 4 }}>
                                <InputLabel id="entityId-label">
                                  ENTITY ID:
                                </InputLabel>
                                <Select
                                  label="PRINCIPAL ENTITY"
                                  labelId="entityId-label"
                                  id="entityId"
                                  value={entityId}
                                  onChange={handleEntityChange}
                                  size="small"
                                >
                                  <MenuItem value="">Select Entity</MenuItem>
                                  {isLoading ? (
                                    <MenuItem disabled>Loading...</MenuItem>
                                  ) : isError ? (
                                    <MenuItem disabled>
                                      No entities available
                                    </MenuItem>
                                  ) : principalEntities.length > 0 ? (
                                    principalEntities.map((entity, index) => (
                                      <MenuItem key={index} value={entity}>
                                        {entity.pe_name} ({entity.pe_id})
                                      </MenuItem>
                                    ))
                                  ) : (
                                    <MenuItem disabled>
                                      No entities available
                                    </MenuItem>
                                  )}
                                </Select>
                              </FormControl>

                              {entityId && (
                                <div className="col-span-2">
                                  <div className="mb-4">
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      fullWidth
                                      onClick={() => setIsTemplateModalOpen(true)}
                                      size="small"
                                    >
                                      Open Template
                                    </Button>
                                  </div>
                                </div>
                              )}

                              {templateId && (
                                <FormControl
                                  fullWidth
                                  variant="outlined"
                                  margin="normal"
                                  sx={{ mb: 4 }}
                                >
                                  <InputLabel id="senderId-label">
                                    SENDER ID
                                  </InputLabel>
                                  <Select
                                    labelId="senderId-label"
                                    id="senderId"
                                    value={senderId}
                                    onChange={handleSenderChange}
                                    label="SENDER ID"
                                    size="small"
                                  >
                                    {headersLoading ? (
                                      <MenuItem disabled>
                                        Loading sender IDs...
                                      </MenuItem>
                                    ) : headersError ? (
                                      <MenuItem disabled>
                                        No sender IDs available
                                      </MenuItem>
                                    ) : headers.length > 0 ? (
                                      headers.map((header) => (
                                        <MenuItem
                                          key={header.header_id}
                                          value={header.header_name}
                                        >
                                          {header.header_name} ({header.header_id}
                                          )
                                        </MenuItem>
                                      ))
                                    ) : (
                                      <MenuItem disabled>
                                        No sender IDs available
                                      </MenuItem>
                                    )}
                                  </Select>
                                </FormControl>
                              )}

                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={enableSchedule}
                                    onChange={(e) => {
                                      const isChecked = e.target.checked;
                                      setEnableSchedule(isChecked);
                                      if (!isChecked) {
                                        const now =
                                          dayjs().format("YYYY-MM-DD HH:mm");
                                        setDateTime(now);
                                        setSendTime(now);
                                      } else {
                                        setMinDateTime(
                                          dayjs().format("YYYY-MM-DDTHH:mm")
                                        );
                                      }
                                    }}
                                  />
                                }
                                label="Do you want to schedule for a future time?"
                                sx={{ mb: 2, "& .MuiFormControlLabel-label": { color: "#000" } }}
                              />

                              {enableSchedule && (
                                <TextField
                                  sx={{ mb: 4 }}
                                  id="dateTime"
                                  label="Schedule Date"
                                  type="datetime-local"
                                  value={sendTime}
                                  onChange={(e) => {
                                    const selectedDateTime = e.target.value;
                                    const now =
                                      dayjs().format("YYYY-MM-DDTHH:mm");

                                    if (dayjs(selectedDateTime).isBefore(now)) {
                                      toast.error(
                                        "Schedule time cannot be in the past"
                                      );
                                      setSendTime(now);
                                    } else {
                                      setSendTime(selectedDateTime);
                                    }
                                  }}
                                  fullWidth
                                  variant="outlined"
                                  InputLabelProps={{ shrink: true }}
                                  inputProps={{
                                    min: minDateTime,
                                  }}
                                />
                              )}

                              {selectedButton === "split" && (
                                <>
                                  <TextField
                                    sx={{ mb: 4 }}
                                    id="time_interval"
                                    label="After Every(N) Minutes"
                                    type="number"
                                    name="time_interval"
                                    min="1"
                                    placeholder="Enter time interval"
                                    fullWidth
                                    variant="outlined"
                                    onChange={(e) =>
                                      settime_interval(e.target.value)
                                    }
                                    InputLabelProps={{ shrink: true }}
                                  />

                                  <TextField
                                    id="batch_size"
                                    label="No of SMS in each Batch"
                                    type="number"
                                    name="batch_size"
                                    min="1"
                                    placeholder="Enter number of files"
                                    fullWidth
                                    variant="outlined"
                                    onChange={(e) =>
                                      setbatch_size(e.target.value)
                                    }
                                    InputLabelProps={{ shrink: true }}
                                  />
                                </>
                              )}

                              {/* Country selection section */}
                              <div className="flex items-center">
                                <label className="block font-medium mt-2">
                                  You are sending Message to:{" "}
                                </label>

                                <div className="py-2 ms-3">
                                  {selectedCountry ? (
                                    <span
                                      className="text-blue-500 cursor-pointer underline"
                                      onClick={handleCountryModalToggle}
                                    >
                                      {selectedCountry.name} (
                                      {selectedCountry.code})
                                    </span>
                                  ) : (
                                    <button
                                      onClick={handleCountryModalToggle}
                                      className="text-blue-500 underline"
                                    >
                                      Select Country
                                    </button>
                                  )}
                                </div>

                                {isCountryModalOpen && (
                                  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                                    <div className="bg-white p-6 rounded-lg max-w-sm w-full relative">
                                      <h2 className="text-xl font-semibold mb-4">
                                        Select Country
                                      </h2>
                                      <button
                                        onClick={() =>
                                          setIsCountryModalOpen(false)
                                        }
                                        className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          className="h-6 w-6"
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24"
                                          strokeWidth="2"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M6 18L18 6M6 6l12 12"
                                          />
                                        </svg>
                                      </button>

                                      {countriesLoading ? (
                                        <p>Loading countries...</p>
                                      ) : countriesError ? (
                                        <p>No countries available</p>
                                      ) : (
                                        <div className="max-h-96 overflow-y-auto">
                                          {countriesData?.data?.length > 0 ? (
                                            countriesData.data.map((country) => (
                                              <div
                                                key={country.customer_country_id}
                                                onClick={() => {
                                                  handleCountrySelect(
                                                    country.country_id,
                                                    country.country.country_name,
                                                    country.country.countrycode
                                                  );
                                                }}
                                                className={`p-3 mb-2 cursor-pointer rounded hover:bg-gray-100 ${selectedCountry?.id ===
                                                  country.country_id
                                                  ? "bg-blue-100"
                                                  : ""
                                                  }`}
                                              >
                                                {country.country.country_name} (
                                                {country.country.countrycode.trim()}
                                                )
                                              </div>
                                            ))
                                          ) : (
                                            <p>No countries available</p>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <Box>
                              <Box>
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  {/* <Typography variant="subtitle1">Enter Your Text</Typography> */}
                                  {smsType === "other" && (
                                    <Box display="flex" alignItems="center">
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={isTransliterationEnabled}
                                            onChange={checkboxClickHandler}
                                          />
                                        }
                                        label={<span style={{ color: "#000" }}>Enable Text Editor:</span>}
                                      />
                                      {isTransliterationEnabled && (
                                        <select
                                          id="ddlLanguage"
                                          onChange={languageChangeHandler}
                                          disabled={!isTransliterationEnabled}
                                          className="ml-4 p-2 border rounded"
                                        >
                                          {Object.entries(languages)
                                            .map(([key, value]) => ({
                                              key,
                                              value,
                                            }))
                                            .map((item, index) => {
                                              return (
                                                <option
                                                  key={index}
                                                  value={item.value}
                                                >
                                                  {item.key}
                                                </option>
                                              );
                                            })}
                                        </select>
                                      )}
                                    </Box>
                                  )}
                                </Box>

                                <TextField
                                  id="txtMessage"
                                  value={smstext}
                                  onChange={handleSmsTextChange}
                                  name="txtMessage"
                                  fullWidth
                                  multiline
                                  rows={5}
                                  placeholder={
                                    smsType === "other"
                                      ? "70 Character Message Enter"
                                      : "160 Character Message Enter"
                                  }
                                  variant="outlined"
                                  margin="normal"
                                />

                                {/* <TextField
                                  id="IDMessage"
                                  value={templateId}
                                  name="txtMessage"
                                  fullWidth
                                  multiline
                                  rows={1}
                                  placeholder="Type Template ID"
                                  variant="outlined"
                                  margin="normal"
                                /> */}

                                <FormGroup row>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        id="allowLongMsg"
                                        checked={isAllow}
                                        onChange={(e) =>
                                          setIsAllow(e.target.checked)
                                        }
                                      />
                                    }
                                    label="Allow Long Message"
                                    sx={{ "& .MuiFormControlLabel-label": { color: "#000" } }}
                                  />
                                </FormGroup>

                                <Box display="flex" gap={2} mt={2}>
                                  <Box
                                    bgcolor="blue"
                                    color="white"
                                    p={2}
                                    borderRadius={1}
                                  >
                                    SMS Count: {smsCountState}
                                  </Box>
                                  <Box
                                    bgcolor="blue"
                                    color="white"
                                    p={2}
                                    borderRadius={1}
                                  >
                                    Char Count: {charCountState}
                                  </Box>
                                </Box>

                                {isLongMessageWarning && (
                                  <Typography color="error" mt={2}>
                                    {/* Warning: Message exceeds the SMS character
                                    limit! */}
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                          </div>

                          {isTemplateModalOpen && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                              <div className="bg-white p-6 rounded-lg max-w-sm w-full">
                                <h2 className="text-xl font-semibold mb-4">
                                  Select Template
                                </h2>
                                {templatesLoading ? (
                                  <div>Loading templates...</div>
                                ) : templatesError ? (
                                  <div>Error loading templates</div>
                                ) : templates.length > 0 ? (
                                  templates.map((template) => (
                                    <button
                                      key={template.template_id}
                                      onClick={() =>
                                        handleTemplateSelect(
                                          template.template_text,
                                          template.trai_template_id
                                        )
                                      }
                                      className="block w-full text-left py-2 px-4 mb-2 bg-gray-100 rounded hover:bg-gray-200"
                                    >
                                      {template.template_text} (
                                      {template.trai_template_id})
                                    </button>
                                  ))
                                ) : (
                                  <div>No templates available</div>
                                )}
                                <button
                                  onClick={() => setIsTemplateModalOpen(false)}
                                  className="w-full mt-4 py-2 px-4 bg-blue-600 text-white rounded"
                                >
                                  Close
                                </button>
                              </div>
                            </div>
                          )}

                          <FormControlLabel
                            control={
                              <Checkbox
                                id="isFlash"
                                checked={isFlash}
                                onChange={(e) => setIsFlash(e.target.checked)}
                              />
                            }
                            label="Is Flash"
                            sx={{ "& .MuiFormControlLabel-label": { color: "#000" } }}
                          />

                          <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={handleSubmit}
                            sx={{ mt: 2 }}
                          >
                            Submit
                          </Button>
                        </Box>
                      )}
                  </div>
                )}
              </Box>
            )}
          </main>
        </div>
      </div>
    </>
  );
};

export default ServiceDropdown;
